import { render, staticRenderFns } from "./gridDetail.vue?vue&type=template&id=95d38222&scoped=true&"
import script from "./gridDetail.vue?vue&type=script&lang=js&"
export * from "./gridDetail.vue?vue&type=script&lang=js&"
import style0 from "./gridDetail.vue?vue&type=style&index=0&id=95d38222&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d38222",
  null
  
)

export default component.exports